import { makeTheme } from 'adl'
import {tint} from 'polished'

let AlogentTheme = makeTheme({
  branding: {
    logo: require('images/alogent/alogent-logo.png'),
    logoInverse: require('images/alogent/alogent-logo-inverse.png'),
    marketingImage: require('images/alogent/nature-bg-1.jpg')
  },
  gradients: {
    light: `linear-gradient(134deg, #e2f6f3 0%, #e7f9e4 100%)`,
    vivid: `linear-gradient(143deg, #408688 0%, #3f745c 100%)`
  }
})

let AltabankTheme = makeTheme({

  colors: {
    interactive: '#276aff',
    primary: '#276aff',
    secondary: '#222'
  },
  branding: {
    logo: require('images/altabank/altabank-logo.svg'),
    logoInverse: require('images/altabank/altabank-logo-inverse.svg'),
    marketingImage: require('images/altabank/altabank-background.jpg')
  },
  gradients: {
    light: `linear-gradient(134deg, #f5f5f5 0%, #e7e7e7 100%)`,
    vivid: `linear-gradient(143deg, #0c49b9 0%, #0f2d69 100%)`
  },
  card: {
    headerBackgroundColor: '#d8e0ff',
    headerTextColor: '#333'
  }
})

let CmeTheme = makeTheme({

  colors: {
    interactive: '#70B3C1',
    primary: '#28538D',
    secondary: '#e1e1e1'
  },
  branding: {
    logo: require('images/cme/logo-normal.png'),
    logoInverse: require('images/cme/logo-inverse.png'),
    marketingImage: require('images/cme/cme-background.jpg')
  },
  gradients: {
    light: `linear-gradient(134deg, #E7F1FF 0%, #E7E7E7 100%)`,
    vivid: `linear-gradient(143deg, #28538D 0%, #122245 100%)`
  },
  card: {
    headerBackgroundColor: '#e1e1e1',
    headerTextColor: '#28538D'
  }
})

let InvestexTheme = makeTheme({
  colors: {
    interactive: '#ff0006'
  },
  gradients: {
    light: `linear-gradient(134deg, #f3e8eb 0%, #e1eeff 100%)`,
    vivid: `linear-gradient(143deg, #022041 0%, #487998 100%)`
  },
  branding: {
    logo: require('images/investex/investex-logo.svg'),
    logoInverse: require('images/investex/investex-logo-inverse.svg'),
    marketingImage: require('images/investex/investex-background.png')
  }
})

let LaunchTheme = makeTheme({
  colors: {
    interactive: '#D32E09',
    primary: '#D32E09',
    secondary: '#00817D'
  },
  branding: {
    logo: require('images/launch/logo-normal.png'),
    logoInverse: require('images/launch/logo-inverse.png'),
    marketingImage: require('images/launch/client-background.jpg')
  },
  gradients: {
    light: `linear-gradient(143deg, #fdf4f1 0%, #f4ded9 100%)`,
    vivid: `linear-gradient(143deg, #114644 0%, #00817D 100%)`
  },
  card: {
    headerBackgroundColor: '#e0e0e0',
    headerTextColor: '#BE2110'
  }
})

let MichiganFirstTheme = makeTheme({
  colors: {
    primary: '#0F2D52',
    secondary: '#72253D',
    interactive: '#0093E8'
  },
  gradients: {
    light: `linear-gradient(134deg, #E1F2FF 0%, #F0F0F0 100%)`,
    vivid: `linear-gradient(143deg, #0093E8 0%, #0E2D52 100%)`
  },
  branding: {
    logo: require('images/michigan-first/logo-normal.svg'),
    logoInverse: require('images/michigan-first/logo-inverse.svg'),
    marketingImage: require('images/michigan-first/michigan-first-background.jpg')
  },
  card: {
    headerBackgroundColor: '#e1e1e1',
    headerTextColor: '#0F2D52'
  }
})

let NumericaTheme = makeTheme({
  colors: {
    interactive: '#004776',
    primary: '#004776',
    secondary: '#C1D72F'
  },
  branding: {
    logo: require('images/numerica/numerica-logo.svg'),
    logoInverse: require('images/numerica/numerica-logo-inverse.svg'),
    marketingImage: require('images/numerica/numerica-background.png')
  },
  gradients: {
    light: `linear-gradient(134deg, ${tint(0.75, '#C1D72F')} 0%, ${tint(0.95, '#C1D72F')} 100%)`,
    vivid: `linear-gradient(143deg, #00304d 0%, #004776 100%)`
  },
  card: {
    headerBackgroundColor: '#C1D72F',
    headerTextColor: '#004776'
  }
})

let ProvidenceTheme = makeTheme({
  colors: {
    interactive: '#C06437',
    primary: '#004B85',
    secondary: '#C39909'
  },
  branding: {
    logo: require('images/providence/logo-normal.svg'),
    logoInverse: require('images/providence/logo-inverse.svg'),
    marketingImage: require('images/providence/client-background.jpg')
  },
  gradients: {
    light: `linear-gradient(143deg, #EDEDED 0%, #D8D8D8 100%)`,
    vivid: `linear-gradient(143deg, #658393 0%, #9db3c2 100%)`
  },
  card: {
    headerBackgroundColor: '#9dae88',
    headerTextColor: '#fff'
  }
})

let ReliantTheme = makeTheme({
  colors: {
    interactive: '#C39909',
    primary: '#004B85',
    secondary: '#C39909'
  },
  branding: {
    logo: require('images/reliant/logo-normal.svg'),
    logoInverse: require('images/reliant/logo-inverse.svg'),
    marketingImage: require('images/reliant/reliant-background.jpg')
  },
  gradients: {
    light: `linear-gradient(143deg, #f4faff 0%, #dbe3e9 100%)`,
    vivid: `linear-gradient(143deg, #496c80 0%, #486b7f 100%)`
  },
  card: {
    headerBackgroundColor: '#ced8e0',
    headerTextColor: '#004B85'
  }
})

let RockyMountainTheme = makeTheme({
  colors: {
    interactive: '#CC9F53',
    primary: '#00263E',
    secondary: '#CC9F53'
  },
  branding: {
    logo: require('images/rocky-mountain/logo-normal.svg'),
    logoInverse: require('images/rocky-mountain/logo-inverse.svg'),
    marketingImage: require('images/rocky-mountain/client-background.jpg')
  },
  gradients: {
    light: `linear-gradient(143deg, #EDEDED 0%, #D8D8D8 100%)`,
    vivid: `linear-gradient(143deg, #00263E 0%, #003651 100%)`
  },
  card: {
    headerBackgroundColor: '#00263E',
    headerTextColor: '#fff'
  }
})

let SiuTheme = makeTheme({
  colors: {
    interactive: '#861f41',
    primary: '#8c1e40',
    secondary: '#000'
  },
  branding: {
    logo: require('images/siu/logo-normal.svg'),
    logoInverse: require('images/siu/logo-inverse.svg'),
    marketingImage: require('images/siu/client-background.jpg')
  },
  gradients: {
    light: `linear-gradient(143deg, ${tint(0.95, '#560421')} 0%, ${tint(0.90, '#8c1e40')} 100%)`,
    vivid: `linear-gradient(143deg, #560421 0%, #8c1e40 100%)`
  },
  card: {
    headerBackgroundColor: '#e2f6f7',
    headerTextColor: '#8c1e40'
  }
})

let TelhioTheme = makeTheme({
  colors: {
    interactive: '#86AD63',
    primary: '#00599A',
    secondary: '#86AD63'
  },
  gradients: {
    light: `linear-gradient(143deg, #F8F9E8 0%, #FCFFDB 100%)`,
    vivid: `linear-gradient(143deg, #00599A 0%, #06141F 100%)`
  },
  branding: {
    logo: require('images/telhio/logo-normal.svg'),
    logoInverse: require('images/telhio/logo-inverse.svg'),
    marketingImage: require('images/telhio/telhio-background.jpg')
  },
  card: {
    headerBackgroundColor: '#D7D7D7',
    headerTextColor: '#00599A'
  }
})


let TrueNorthTheme = makeTheme({
  colors: {
    interactive: '#006893'
  },
  gradients: {
    light: `linear-gradient(134deg, #daf7ff 0%, #eff9ff 100%)`,
    vivid: `linear-gradient(143deg, #454f4b 0%, #1f2422 100%)`
  },
  branding: {
    logo: require('images/true-north/true-north-logo.svg'),
    logoInverse: require('images/true-north/true-north-logo-inverse.svg'),
    marketingImage: require('images/true-north/true-north-background.jpg')
  }
})

let WestconsinTheme = makeTheme({
  colors: {
    interactive: '#00964c',
    primary: '#00964c',
    secondary: '#0054a4'
  },
  gradients: {
    light: `linear-gradient(143deg, #e3eeff 0%, #f3e7e9 100%)`,
    vivid: `linear-gradient(143deg, #03305a 0%, #0054a4 100%)`
  },
  branding: {
    logo: require('images/westconsin/logo-normal.svg'),
    logoInverse: require('images/westconsin/logo-inverse.svg'),
    marketingImage: require('images/westconsin/westconsin-background.jpg')
  },
  card: {
    headerBackgroundColor: '#00964c',
    headerTextColor: '#fff'
  }
})

let WildfireTheme = makeTheme({
  colors: {
    interactive: '#7AC143',
    primary: '#00549E',
    secondary: '#7AC143'
  },
  gradients: {
    light: `linear-gradient(143deg, #EFFFE2 0%, #F1FDE5 100%)`,
    vivid: `linear-gradient(143deg, #00549E 0%, #122245 100%)`
  },
  branding: {
    logo: require('images/wildfire/logo-normal.svg'),
    logoInverse: require('images/wildfire/logo-inverse.svg'),
    marketingImage: require('images/wildfire/wildfire-background.jpg')
  },
  card: {
    headerBackgroundColor: '#7EA0CF',
    headerTextColor: '#fff'
  }
})


const ThemePresets = [
  {
    label: 'Default',
    theme: AlogentTheme
  },
  // {
  //   label: 'Preset AB',
  //   theme: AltabankTheme
  // },
  {
    label: 'Preset CM',
    theme: CmeTheme
  },
  {
    label: 'Preset IT',
    theme: InvestexTheme
  },
  {
    label: 'Preset LA',
    theme: LaunchTheme
  },
  {
    label: 'Preset MF',
    theme: MichiganFirstTheme
  },
  {
    label: 'Preset NU',
    theme: NumericaTheme
  },
  {
    label: 'Preset PR',
    theme: ProvidenceTheme
  },
  {
    label: 'Preset RE',
    theme: ReliantTheme
  },
  {
    label: 'Preset SI',
    theme: SiuTheme
  },
  {
    label: 'Preset RM',
    theme: RockyMountainTheme
  },
  {
    label: 'Preset TE',
    theme: TelhioTheme
  },
  {
    label: 'Preset TN',
    theme: TrueNorthTheme
  },
  {
    label: 'Preset WF',
    theme: WildfireTheme
  },
  {
    label: 'Preset WC',
    theme: WestconsinTheme
  }
]

export default ThemePresets
